import { DashboardLayout as DashboardLayoutService } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import BalanceSheetIcon from "../Icons/BalanceSheetIcon";
import ChartOfAccountsIcon from "../Icons/ChartOfAccountsIcon";
import CommonIcon from "../Icons/CommonIcon";
import DashBoardIcon from "../Icons/DashboardIcon";
import GearIcon from "../Icons/GearIcon";
import GeneralLedgerIcon from "../Icons/GeneralLedgerIcon";
import JournalEntryIcon from "../Icons/JournalEntryIcon";
import ProfitAndLossIcon from "../Icons/ProfitAndLossIcon";
import ReportsIcon from "../Icons/ReportsIcon";
import SetupIcon from "../Icons/SetupIcon";
import TrialBalanceIcon from "../Icons/TrialBalanceIcon";
import SetupForm from "../components/GetStarted/SetupForm";
import PopupModal from "../components/Reusable/Modal";
import APIS from "../constant/Endpoint";
import useGetHook from "../customHooks/useGetHook";
import { getKey } from "../helpers/sessionKey";
import WelcomeIcon from "../Icons/WelcomeIcon";
import DailyNoteIcon from "../Icons/DailyNoteIcon";

export const shouldShowWelcome = getKey("shouldShowWelcome");

const DashboardLayout = () => {
  const [isOpenSettingPopup, setIsOpenSettingPopup] = useState(false);
  const { data } = useGetHook({
    queryKey: [`company-profile`],
    url: `${APIS.COMPANY_PROFILE}`,
    params: {},
  });

  useEffect(() => {
    if (data && Object.keys(data).length === 0) {
      setIsOpenSettingPopup(true);
    }
  }, [data]);

  const navigation: any = [
    {
      name: "Overview",
      href: "",
      icon: "",
      children: [
        ...(shouldShowWelcome === "true" || shouldShowWelcome === null
          ? [
              {
                name: "Welcome",
                href: "/",
                icon: WelcomeIcon,
                activeIcon: WelcomeIcon,
              },
              {
                name: "Dashboard",
                href: "/accounting",
                icon: DashBoardIcon,
                activeIcon: DashBoardIcon,
              },
            ]
          : [
              {
                name: "Dashboard",
                href: "/accounting",
                icon: DashBoardIcon,
                activeIcon: DashBoardIcon,
              },
            ]),
      ],
    },

    {
      name: "Master",
      href: "",
      icon: CommonIcon,
      activeIcon: CommonIcon,
      children: [
        {
          name: "Account Info",
          href: "/accounting/account",
          icon: JournalEntryIcon,
          activeIcon: JournalEntryIcon,
        },
        ...(data?.type === "Trading"
          ? [
              {
                name: "Inventory Info",
                href: "/accounting/inventory",
                icon: JournalEntryIcon,
                activeIcon: JournalEntryIcon,
              },
            ]
          : [
              {
                name: "Service Info",
                href: "/accounting/service",
                icon: JournalEntryIcon,
                activeIcon: JournalEntryIcon,
              },
            ]),
        {
          name: "Customer",
          href: "/accounting/customer",
          icon: JournalEntryIcon,
          activeIcon: JournalEntryIcon,
        },
        {
          name: "Supplier",
          href: "/accounting/supplier",
          icon: JournalEntryIcon,
          activeIcon: JournalEntryIcon,
        },
      ],
    },

    {
      name: "Transaction",
      href: "",
      icon: CommonIcon,
      activeIcon: CommonIcon,
      children: [
        {
          name: "Cash",
          href: "/accounting/cash-payment",
          icon: CommonIcon,
          activeIcon: JournalEntryIcon,
        },
        {
          name: "Bank ",
          href: "/accounting/bank-payment",
          icon: CommonIcon,
          activeIcon: JournalEntryIcon,
        },
        {
          name: "Journal Voucher",
          href: "/accounting/journal-voucher",
          icon: JournalEntryIcon,
          activeIcon: JournalEntryIcon,
        },
        {
          name: "Purchase",
          href: "/accounting/purchase",
          icon: JournalEntryIcon,
          activeIcon: JournalEntryIcon,
        },
        {
          name: "Purchase Return",
          href: "/accounting/purchase-return",
          icon: JournalEntryIcon,
          activeIcon: JournalEntryIcon,
        },
        {
          name: "Sales",
          href: "/accounting/sales",
          icon: JournalEntryIcon,
          activeIcon: JournalEntryIcon,
        },
        {
          name: "Sales Return",
          href: "/accounting/sales-return",
          icon: JournalEntryIcon,
          activeIcon: JournalEntryIcon,
        },
        {
          name: "Credit Note",
          href: "/accounting/credit-note",
          icon: JournalEntryIcon,
          activeIcon: JournalEntryIcon,
        },
        {
          name: "Debit Note",
          href: "/accounting/debit-note",
          icon: JournalEntryIcon,
          activeIcon: JournalEntryIcon,
        },
      ],
    },
    ...(data?.type === "Trading"
      ? [
          {
            name: "Inventory",
            href: "",
            icon: ReportsIcon,
            activeIcon: ReportsIcon,
            children: [
              {
                name: "Stock Trial",
                href: "/accounting/stock-trial-normal",
                icon: GeneralLedgerIcon,
                activeIcon: GeneralLedgerIcon,
              },
              {
                name: "Stock Valuation",
                href: "/accounting/stock-valuation-normal",
                icon: GeneralLedgerIcon,
                activeIcon: GeneralLedgerIcon,
              },
              {
                name: "Stock Ledger",
                href: "/accounting/stock-ledger-normal",
                icon: GeneralLedgerIcon,
                activeIcon: GeneralLedgerIcon,
              },
              {
                name: "Stock Movement",
                href: "/accounting/stock-movement-normal",
                icon: GeneralLedgerIcon,
                activeIcon: GeneralLedgerIcon,
              },
            ],
          },
        ]
      : []),
    {
      name: "Reports",
      href: "",
      icon: ReportsIcon,
      activeIcon: ReportsIcon,
      children: [
        {
          name: "General Ledger",
          href: "/accounting/general-ledger-account",
          icon: GeneralLedgerIcon,
          activeIcon: GeneralLedgerIcon,
        },
        // {
        //   name: "Daily Note",
        //   href: "/daily-notes",
        //   icon: DailyNoteIcon,
        //   activeIcon: DailyNoteIcon,
        // },
        ...(data?.type === "Service"
          ? [
              {
                name: "Service Report",
                href: "/accounting/service-report",
                icon: JournalEntryIcon,
                activeIcon: JournalEntryIcon,
              },
            ]
          : []),
      ],
    },
    {
      name: "CBMS Reports",
      href: "",
      icon: ReportsIcon,
      activeIcon: ReportsIcon,
      children: [
        {
          name: "Purchase Register",
          href: "/accounting/purchase-register",
          icon: GeneralLedgerIcon,
          activeIcon: GeneralLedgerIcon,
        },
        {
          name: "Sales Register",
          href: "/accounting/sales-register",
          icon: GeneralLedgerIcon,
          activeIcon: GeneralLedgerIcon,
        },
        {
          name: "Purchase Return Register",
          href: "/accounting/purchase-return-register",
          icon: GeneralLedgerIcon,
          activeIcon: GeneralLedgerIcon,
        },
        {
          name: "Sales Return Register",
          href: "/accounting/sales-return-register",
          icon: GeneralLedgerIcon,
          activeIcon: GeneralLedgerIcon,
        },
      ],
    },
    {
      name: "Financial Statments",
      herf: "",
      children: [
        {
          name: "Profit and Loss",
          href: "/accounting/profit-and-loss",
          icon: ProfitAndLossIcon,
          activeIcon: ProfitAndLossIcon,
        },
        {
          name: "Balance Sheet",
          href: "/accounting/balance-sheet",
          icon: BalanceSheetIcon,
          activeIcon: BalanceSheetIcon,
        },
        {
          name: "Trial Balance",
          href: "/accounting/trial-balance-grouped",
          icon: TrialBalanceIcon,
          activeIcon: TrialBalanceIcon,
        },
      ],
    },
    {
      name: "Setup",
      href: "",
      icon: SetupIcon,
      activeIcon: SetupIcon,
      children: [
        {
          name: "Charts of Accounts",
          href: "/accounting/charts-of-accounts",
          icon: ChartOfAccountsIcon,
          activeIcon: ChartOfAccountsIcon,
        },
        // {
        //   name: "Party",
        //   href: "/accounting/party",
        //   icon: ChartOfAccountsIcon,
        //   activeIcon: ChartOfAccountsIcon,
        // },
        {
          name: "Settings",
          href: "/accounting/profile",
          icon: GearIcon,
          activeIcon: GearIcon,
        },
      ],
    },
  ];

  return (
    <>
      <DashboardLayoutService navigation={navigation}>
        <div className={tw`h-full p-2 overflow-y-auto`}>
          <Outlet />
        </div>
      </DashboardLayoutService>
      <PopupModal
        isOpen={isOpenSettingPopup}
        setIsOpen={() => console.log("Modal Close")}
        title="Setup Your Organization"
      >
        <div className={tw`min-w-[700px]`}>
          <SetupForm setModalPopup={setIsOpenSettingPopup} />
        </div>
      </PopupModal>
    </>
  );
};

export default DashboardLayout;

